























import { Vue, Component } from 'vue-property-decorator';
import { Icon, Popup, List, Toast } from 'vant';
import { getCommentsByTag, getCommentsCount, vote } from '../api';
import CommentItem from '../components/CommentItem.vue';

Vue.use(Icon).use(Popup).use(List).use(Toast);

let voteThrottleTimer: any = null;
const VOTE_THROTTLE_DELAY = 600;

@Component({
  components: {
    CommentItem,
  },
})
export default class CommentListWithSpecificTag extends Vue {
  allComments: any[] = [];
  loading = false;
  page = 1;
  finished = false;
  totalCount = 0;

  async created() {
    this.getAllComments();
    const ret = await getCommentsCount(this.$route.query.tagId as string);
    this.totalCount = ret.data;
  }

  // 获取全部评论
  async getAllComments() {
    this.loading = true;
    const ret = await getCommentsByTag(
      this.page,
      this.$route.query.tagId as string,
    );
    this.loading = false;
    if (ret.data.length) {
      this.page++;
    } else {
      this.finished = true;
    }
    this.allComments = [...this.allComments, ...ret.data];
  }
  onTagInCommentItemClick(tagItem: any) {
    location.href = `${location.origin}${location.pathname}?tagId=${tagItem.id}&name=${tagItem.name}`;
  }
  async onVote(commentItemIndex: number) {
    if (voteThrottleTimer) {
      Toast('点赞手速不要太快哦');
      clearTimeout(voteThrottleTimer);
      // voteThrottleTimer = null;
    }
    voteThrottleTimer = setTimeout(async () => {
      const ret: any = await vote(this.allComments[commentItemIndex].commentId);
      if (ret.code === 200) {
        this.allComments[commentItemIndex].votes =
          Number(this.allComments[commentItemIndex].votes) + 1;
      }
      voteThrottleTimer = null;
      Toast(ret.msg);
    }, VOTE_THROTTLE_DELAY);
  }
}
